import { ESearchTypes } from "components/SearchBar/typings";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { ListType } from "dto/ListType";

const SearchDropdown: FC<Props> = ({
  onChoose,
  listType,
}) => {
  //if (!refWrapper?.current) return <></>;

  const { t } = useTranslation();
  const refClose = useRef(null);

  // useOnClickOutside(refClose, () => {
  //   toggle();
  // });

  return (
    <div
      ref={refClose}
      style={
        {
          // left: `${position.left}px`,
          // top: `${position.top}px`,
        }
      }
      className={styles.dropdown}
    >
      <div onClick={() => onChoose(ESearchTypes.STATUS)} className={styles.box}>
        {t("common.status")}
      </div>
      <div onClick={() => onChoose(ESearchTypes.TAG)} className={styles.box}>
        {listType === ListType.Cases ? t("cases.caseKind") : t("common.tags")}
      </div>
      {(listType === ListType.Incoming || listType === ListType.Outgoing) && (
        <div
          onClick={() => onChoose(ESearchTypes.CHANNEL)}
          className={styles.box}
        >
          {t("common.communicationChannels")}
        </div>
      )}
      {(listType === ListType.Cases || listType === ListType.Tasks) && (
        <div
          onClick={() => onChoose(ESearchTypes.SHARED)}
          className={styles.box}
        >
          {t("cases.sharedItems")}
        </div>
      )}
    </div>
  );
};

export default SearchDropdown;
